import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user/user.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-export-employee-details',
  templateUrl: './export-employee-details.component.html',
  styleUrls: ['./export-employee-details.component.scss'],
})
export class ExportEmployeeDetailsComponent implements OnInit {
  generateButtonText: string = 'Generate Report';
  generateDisabled: boolean = false;
  fields = [
    { name: 'Name', checked: true, mandatory: true },
    { name: 'Employee Id', checked: true, mandatory: true },
    {
      name: 'BA Email',
      checked: true,
      mandatory: true,
    },
    { name: 'Title', checked: true, mandatory: true },
    { name: 'Date of Joining', checked: true, mandatory: true },
    { name: 'Total Experience', checked: true, mandatory: true },
    { name: 'BA Experience', checked: true, mandatory: true },
    { name: 'Prior Experience', checked: true, mandatory: true },
    { name: 'Employment Type', checked: false, mandatory: false },
    {
      name: 'Capability',
      checked: false,
      mandatory: false,
    },
    { name: 'Career Manager', checked: false, mandatory: false },
    { name: 'Geo Location', checked: false, mandatory: false },
    { name: 'Base Location', checked: false, mandatory: false },
    { name: 'Current Location', checked: false, mandatory: false },
    { name: 'Aadhaar', checked: false, mandatory: false },
    { name: 'PAN', checked: false, mandatory: false },
    { name: 'Voter Id', checked: false, mandatory: false },
    {
      name: 'Mobile No.',
      checked: false,
      mandatory: false,
    },
    { name: 'Date of Birth', checked: false, mandatory: false },
    { name: 'Gender', checked: false, mandatory: false },
    { name: 'Blood Group', checked: false, mandatory: false },
    { name: 'Marital Status', checked: false, mandatory: false },
    { name: 'Personal Email', checked: false, mandatory: false },
    {
      name: 'Current Address',
      checked: false,
      mandatory: false,
    },
    { name: 'Permanent Address', checked: false, mandatory: false },
    {
      name: 'Emergency Contact',
      checked: false,
      mandatory: false,
    },
    {
      name: 'Local Emergency Contact',
      checked: false,
      mandatory: false,
    },

    // { name: 'Visas Available', checked: false, mandatory: false },
    // { name: 'Passport Details', checked: false, mandatory: false }
  ];

  fieldMappings = {
    Name: 'firstName',
    'Employee Id': 'employeeId',
    'BA Email': 'email',
    Title: 'jobTitle',
    'Date of Joining': 'joiningDate',
    'Employment Type': 'employmentType',
    Capability: 'capability',
    'Career Manager': 'careerManagerName',
    'Geo Location': 'geoLocation',
    'Base Location': 'baseOfficeLocation',
    'Current Location': 'currentLocation',
    'Total Experience': 'totalExperience',
    'BA Experience': 'baExperience',
    'Prior Experience': 'priorExperience',
    Aadhaar: 'aadharNo',
    PAN: 'panNo',
    'Voter Id': 'voterId',
    'Mobile No.': 'mobileNumber',
    'Date of Birth': 'dateOfBirth',
    Gender: 'gender',
    'Blood Group': 'bloodGroup',
    'Marital Status': 'relationship_status',
    'Personal Email': 'personalEmailId',
    'Current Address': 'currentAddress',
    'Permanent Address': 'permanentAddress',
    'Emergency Contact': 'emergencyContact',
    'Local Emergency Contact': 'localEmergencyContact',
  };
  selectedFields: string[] = [];
  fgjoiningdate;
  constructor(
    public dialogRef: MatDialogRef<ExportEmployeeDetailsComponent>,
    public userService: UserService
  ) {}

  ngOnInit(): void {}

  updateSelectedFields() {
    this.selectedFields = this.fields
      .filter((field) => field.checked)
      .map((field) => field.name);
  }

  generateReport() {
    this.generateButtonText = 'Please wait..';
    this.generateDisabled = true;
    this.userService.getAllUsersDetails().subscribe(
      (res) => {
        const parsedData = res.body;
        const filteredData = this.filterData(parsedData);

        // Apply your original calculation logic
        filteredData.forEach((item) => {
          // Apply formatting transformations
          if (item['Blood Group']) {
            item['Blood Group'] = this.convertToTitleCase(item['Blood Group']);
          }
          if (item['Date of Birth']) {
            item['Date of Birth'] = this.convertToTitleCase(
              item['Date of Birth'].substring(0, 10)
            );
          }
          if (item['Marital Status']) {
            item['Marital Status'] = this.convertToTitleCase(
              item['Marital Status']
            );
          }
          if (item['Geo Location']) {
            item['Geo Location'] = this.convertToTitleCase(
              item['Geo Location']
            );
          }
          if (item['Base Location']) {
            item['Base Location'] = this.convertToTitleCase(
              item['Base Location']
            );
          }
          if (item['Title']) {
            item['Title'] = this.convertToTitleCase(item['Title']);
          }
          if (item['Capability']) {
            item['Capability'] = this.convertToTitleCase(item['Capability']);
          }
          if (item['Employment Type']) {
            item['Employment Type'] = this.convertToTitleCase(
              item['Employment Type']
            );
          }

          // Calculate BA Experience
          if (item['Date of Joining']) {
            item['BA Experience'] = this.baExperienceCalculator(
              item['Date of Joining'].substring(0, 10)
            );
          }

          // Calculate Prior Experience - need to get original data for this
          const originalItem = parsedData.find(
            (orig) => orig.employeeId === item['Employee Id']
          );
          if (originalItem && originalItem.previousEmployment) {
            item['Prior Experience'] = this.priorExperienceCalculator(
              originalItem.previousEmployment,
              item['Date of Joining'].substring(0, 10)
            );
          }

          // Calculate Total Experience
          if (originalItem && originalItem.previousEmployment) {
            item['Total Experience'] = this.calculateOverAllExperince(
              originalItem.previousEmployment,
              item['Date of Joining'].substring(0, 10)
            );
          }
        });

        // Reorder the fields in each row to match desired order
        const desiredFieldOrder = [
          'Name',
          'Employee Id',
          'BA Email',
          'Title',
          'Date of Joining',
          'Employment Type',
          'Capability',
          'Career Manager',
          'Geo Location',
          'Base Location',
          'Current Location',
          'Total Experience',
          'BA Experience',
          'Prior Experience',
          'Aadhaar',
          'PAN',
          'Voter Id',
          'Mobile No.',
          'Date of Birth',
          'Gender',
          'Blood Group',
          'Marital Status',
          'Personal Email',
          'Current Address',
          'Permanent Address',
          'Emergency Contact',
          'Local Emergency Contact',
        ];

        const reorderedData = filteredData.map((item) => {
          const reorderedItem = {};
          desiredFieldOrder.forEach((field) => {
            if (item.hasOwnProperty(field)) {
              reorderedItem[field] = item[field];
            }
          });
          return reorderedItem;
        });

        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(reorderedData);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'All Employee Details.xlsx');
        this.generateButtonText = 'downloading...';
        this.generateDisabled = false;
        setTimeout(() => {
          this.matDialogClose();
        }, 1000);
      },
      (e) => {
        this.generateDisabled = false;
        this.generateButtonText = 'Generate Report';
      }
    );
  }

  convertToTitleCase(word) {
    return word
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  filterData(parsedData: any) {
    const selectedFieldsWithNames = this.fields.filter(
      (field) => field.checked
    );

    // Define your exact desired field order
    const desiredFieldOrder = [
      'Name',
      'Employee Id',
      'BA Email',
      'Title',
      'Date of Joining',
      'Employment Type',
      'Capability',
      'Career Manager',
      'Geo Location',
      'Base Location',
      'Current Location',
      'Total Experience',
      'BA Experience',
      'Prior Experience',
      'Aadhaar',
      'PAN',
      'Voter Id',
      'Mobile No.',
      'Date of Birth',
      'Gender',
      'Blood Group',
      'Marital Status',
      'Personal Email',
      'Current Address',
      'Permanent Address',
      'Emergency Contact',
      'Local Emergency Contact',
    ];

    // Sort selected fields based on desired order
    selectedFieldsWithNames.sort((a, b) => {
      const indexA = desiredFieldOrder.indexOf(a.name);
      const indexB = desiredFieldOrder.indexOf(b.name);
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });

    const filteredData = parsedData.map((item) => {
      // Prepare basic data transformations
      item.firstName = item.firstName + ' ' + item.lastName;

      // Handle emergency contacts
      item.emergencyContact =
        (item?.emergencyContactName || '') +
        ' ' +
        (item?.emergencyContact || '');
      item.localEmergencyContact =
        (item?.localEmergencyContactName || '') +
        ' ' +
        (item?.localEmergencyContact || '');

      // Handle joining date
      if (item.joiningDate || item.fgJoiningDate) {
        const joiningValue = item.fgJoiningDate ?? item.joiningDate;
        item['Date of Joining'] = joiningValue.substring(0, 10);
        item.joiningDate = joiningValue.substring(0, 10);
      }

      const filteredItem = {};

      // Create filtered item with all selected fields in correct order
      selectedFieldsWithNames.forEach((field) => {
        const fieldKey = this.fieldMappings[field.name];

        if (
          fieldKey &&
          item[fieldKey] !== undefined &&
          item[fieldKey] !== null
        ) {
          filteredItem[field.name] = item[fieldKey];
        } else {
          // Always include the field, even if empty
          filteredItem[field.name] = '';
        }
      });

      return filteredItem;
    });

    return filteredData;
  }

  calculateOverAllExperince(previousEmployment, joiningDate) {
    let totalYears: number = 0;
    let totalMonths: number = 0;
    for (let r of previousEmployment) {
      const startDate = new Date(r.startDate);
      const endDate = new Date(r.endDate);

      let yearsDiff = endDate.getFullYear() - startDate.getFullYear();
      let monthsDiff = endDate.getMonth() - startDate.getMonth();

      if (monthsDiff < 0) {
        monthsDiff += 12;
        yearsDiff--;
      }

      totalYears += yearsDiff;
      totalMonths += monthsDiff;
    }

    const currentStartDate = new Date(joiningDate);
    const currentDate1 = new Date();
    let currentYears =
      currentDate1.getFullYear() - currentStartDate.getFullYear();
    let currentMonths = currentDate1.getMonth() - currentStartDate.getMonth();

    if (currentMonths < 0) {
      currentMonths += 12;
      currentYears--;
    }

    totalYears += currentYears;
    totalMonths += currentMonths;

    if (totalMonths >= 12) {
      const extraYears = Math.floor(totalMonths / 12);
      totalYears += extraYears;
      totalMonths -= extraYears * 12;
    }

    return `${totalYears} years and ${totalMonths} months`;
  }
  priorExperienceCalculator(previousEmployment, joiningDate) {
    let totalYears: number = 0;
    let totalMonths: number = 0;
    for (let r of previousEmployment) {
      //console.log('Previous employement: ', previousEmployment);
      const startDate = new Date(r.startDate);
      const endDate = new Date(r.endDate);

      let yearsDiff = endDate.getFullYear() - startDate.getFullYear();
      let monthsDiff = endDate.getMonth() - startDate.getMonth();

      if (monthsDiff < 0) {
        monthsDiff += 12;
        yearsDiff--;
      }

      totalYears += yearsDiff;
      totalMonths += monthsDiff;
    }

    if (totalMonths >= 12) {
      const extraYears = Math.floor(totalMonths / 12);
      totalYears += extraYears;
      totalMonths -= extraYears * 12;
    }

    return `${totalYears} years and ${totalMonths} months`;
  }
  baExperienceCalculator(joiningDate) {
    const startDate = new Date(joiningDate);
    const currentDate = new Date();

    if (isNaN(startDate.getTime())) {
      return '0 years and 0 months';
    }

    let yearsDiff = currentDate.getFullYear() - startDate.getFullYear();
    let monthsDiff = currentDate.getMonth() - startDate.getMonth();

    if (monthsDiff < 0) {
      monthsDiff += 12;
      yearsDiff--;
    }

    if (monthsDiff >= 12) {
      const extraYears = Math.floor(monthsDiff / 12);
      yearsDiff += extraYears;
      monthsDiff -= extraYears * 12;
    }

    return `${yearsDiff} years and ${monthsDiff} months`;
  }
  matDialogClose() {
    this.dialogRef.close();
  }
}